const contentful = require('contentful')
export const client = contentful.createClient({
    space: 'bbnewkew8oy0',
    accessToken: '1g0Vz-lV9fMv9lh_Ee9KYQRDIHoVm9wyZUzM0Bt6ZDA'
})